import React from 'react';

interface BundlePreparationOverlayProps {
  isOpen: boolean;
  title?: string;
  message?: string;
}

export default function BundlePreparationOverlay({
  isOpen,
  title = 'Preparing your Bundle...',
  message = 'We are pulling in your subscription items and matching the right delivery options.',
}: BundlePreparationOverlayProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 10000,
          background:
            'radial-gradient(circle at top, rgba(249,115,22,0.16), transparent 38%), linear-gradient(180deg, #FFFDF9 0%, #FFF7ED 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '360px',
            background: 'rgba(255,255,255,0.88)',
            border: '1px solid rgba(249,115,22,0.12)',
            borderRadius: '28px',
            boxShadow: '0 24px 60px rgba(249,115,22,0.14)',
            padding: '32px 28px',
            textAlign: 'center',
            backdropFilter: 'blur(14px)',
            animation: 'bundleOverlayRise 0.28s ease-out',
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '92px',
              height: '92px',
              margin: '0 auto 24px',
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: '10px',
                borderRadius: '50%',
                background: 'rgba(249,115,22,0.08)',
                animation: 'bundlePulse 1.6s ease-in-out infinite',
              }}
            />
            <div
              style={{
                position: 'absolute',
                inset: 0,
                borderRadius: '50%',
                border: '5px solid rgba(249,115,22,0.12)',
                borderTopColor: 'var(--bx-brand)',
                animation: 'bundleSpin 0.9s linear infinite',
              }}
            />
            <div
              style={{
                position: 'absolute',
                inset: '24px',
                borderRadius: '24px',
                background: 'var(--bx-brand-soft)',
                color: 'var(--bx-brand-strong)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '26px',
                fontWeight: 800,
                boxShadow: 'inset 0 0 0 1px rgba(249,115,22,0.08)',
              }}
            >
              B
            </div>
          </div>

          <h2
            style={{
              fontSize: '24px',
              lineHeight: '1.15',
              letterSpacing: '-0.03em',
              marginBottom: '10px',
              color: 'var(--bx-ink)',
            }}
          >
            {title}
          </h2>

          <p
            style={{
              fontSize: '14px',
              lineHeight: '1.6',
              color: 'var(--bx-ink-2)',
              marginBottom: '18px',
            }}
          >
            {message}
          </p>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '8px',
            }}
          >
            {[0, 1, 2].map((dot) => (
              <span
                key={dot}
                style={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: dot === 1 ? '#F97316' : '#FDBA74',
                  animation: `bundleDotBounce 1s ease-in-out ${dot * 0.12}s infinite`,
                }}
              />
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes bundleSpin {
          to { transform: rotate(360deg); }
        }

        @keyframes bundlePulse {
          0%, 100% { transform: scale(0.94); opacity: 0.65; }
          50% { transform: scale(1.05); opacity: 1; }
        }

        @keyframes bundleDotBounce {
          0%, 80%, 100% { transform: translateY(0); opacity: 0.45; }
          40% { transform: translateY(-5px); opacity: 1; }
        }

        @keyframes bundleOverlayRise {
          from { opacity: 0; transform: translateY(10px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </>
  );
}
